/**
 * Personnel: staff records, payroll, and the parent directory.
 *
 * Part of the route table (see ./index.ts). Split by domain so adding a
 * screen touches one small file instead of one long one.
 */
import { lazy } from "react";
import type { AppRoute } from "./types";

export const PEOPLE_ROUTES: AppRoute[] = [
  {
    path: "/staff",
    title: "Personnel",
    component: lazy(() => import("@/pages/staff/StaffPage")),
    perms: ["people.staff.list"],
    nav: { label: "Personnel", order: 20, group: "Personnel" },
  },
  {
    path: "/hr",
    title: "Ressources humaines",
    component: lazy(() => import("@/pages/hr/HrPage")),
    perms: ["people.staff.list", "people.staff.view"],
    nav: { label: "Paie & RH", order: 21, group: "Personnel" },
  },
  {
    path: "/my-payroll",
    title: "Mon bulletin de paie",
    component: lazy(() => import("@/pages/my-payroll/MyPayrollPage")),
    perms: ["hr.payroll.self.view"],
    nav: { label: "Mon bulletin", order: 22, group: "Personnel" },
  },
  {
    path: "/parents-directory",
    title: "Annuaire des parents",
    component: lazy(() => import("@/pages/parents-directory/ParentsDirectoryPage")),
    perms: ["people.parent.list"],
    nav: { label: "Annuaire des parents", order: 50, group: "Administration" },
  },
];
